// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"98b1551c","135":"b33dfe10","691":"1afd2e9d","739":"9db8fb82"}[chunkId] + ".chunk.js";
};